import { render, staticRenderFns } from "./FeedbackAnalyticsPie.vue?vue&type=template&id=2670689e&"
import script from "./FeedbackAnalyticsPie.vue?vue&type=script&lang=js&"
export * from "./FeedbackAnalyticsPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports